/**
 * DCBL Cookie Consent - WordPress Plugin Frontend
 *
 * This file serves as the entry point, initializing the consent manager
 * with configuration passed from WordPress via window.dcblCookieConsentConfig
 */

import { ConsentManager } from "./consent-manager";
import type { PluginConfig } from "./config";
import "./styles/main.css";

declare global {
	interface Window {
		dcblCookieConsentConfig?: PluginConfig;
		DCBLCookieConsent?: ConsentManager;
	}
}

// Initialize when DOM is ready
function init(): void {
	const config = window.dcblCookieConsentConfig;

	if (!config || !config.enabled) {
		if (process.env.NODE_ENV !== "production") {
			console.log("[DCBL Cookie Consent] Plugin disabled or no config found");
		}
		return;
	}

	// Check for bots if hideFromBots is enabled
	if (config.hideFromBots && isBot()) {
		if (process.env.NODE_ENV !== "production") {
			console.log(
				"[DCBL Cookie Consent] Bot detected, skipping initialization",
			);
		}
		return;
	}

	// Create and expose the consent manager globally
	window.DCBLCookieConsent = new ConsentManager(config);
}

function isBot(): boolean {
	const botPattern =
		/bot|crawl|spider|slurp|yahoo|bingpreview|facebookexternalhit|googlebot|google-inspectiontool|ia_archiver|teoma/i;
	return botPattern.test(navigator.userAgent);
}

// Wait for DOM ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}

// Export for external usage
export { ConsentManager } from "./consent-manager";
export type { PluginConfig, StorageConfig, StoragesConfig } from "./config";
